import React from "react"
import { graphql } from "gatsby"

import Layout from "../layouts"
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        '& a': {

        },
        '& .admonitionblock.tip' : {
            padding:theme.spacing(2),
            backgroundColor: theme.palette.warning.main,
            borderRadius: theme.shape.borderRadius,
            '& .icon' : {
                paddingRight: theme.spacing(2)
            },
            '& .content': {
                paddingLeft: theme.spacing(2)
            }
        },
        '& table.tableblock': {
            tableLayout: 'auto',
            marginTop: theme.spacing(4),
            borderCollapse: 'collapse'
        },
        '& table.tableblock td': {
            borderBottom: '1px solid lightgrey'
        },
        '& table.tableblock thead th': {
            textAlign:'left',
            borderBottom: '1px solid grey'
        }

    }
}))
const Article = (props) => {
        let classes = useStyles()
        // Pour le moment tous les documents format asciidoc sont protégés
        let authorizationRequired = true
        return (
            <Layout title={props.data.asciidoc.document.title} authorizationRequired={authorizationRequired}>
                <div className={classes.root}
                    dangerouslySetInnerHTML={{ __html: props.data.asciidoc.html }}
                />
            </Layout>
        )

}

export default Article

export const pageQuery = graphql`
    query($id: String!) {
        asciidoc(id: { eq: $id }) {
            html
            document {
                title
            }
        }
    }
`